import { render, staticRenderFns } from "./PlatformList.vue?vue&type=template&id=34240548&scoped=true"
import script from "./PlatformList.vue?vue&type=script&lang=ts&setup=true"
export * from "./PlatformList.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./PlatformList.vue?vue&type=style&index=0&id=34240548&prod&lang=less&scoped=true"
import style1 from "./PlatformList.vue?vue&type=style&index=1&id=34240548&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34240548",
  null
  
)

export default component.exports